export {getEllipsisText} from './get-ellipsis-text'
